import React from "react";

const groupByField = (issues) => {
  const map = new Map();
  issues.forEach((issue) => {
    const field = issue.attributeNames && issue.attributeNames[0] || "general";
    if (!map.has(field)) map.set(field, []);
    map.get(field).push(issue);
  });
  return Array.from(map.entries()); 
};

const AmazonProductListingUpdatePopup = ({ data }) => {
  if (!data) return <div>Loading...</div>;

  const { sku, status, submissionId, issues = [], updated_fields = []  } = data;
  const errors = issues.filter((i) => i.severity === "ERROR").length;
  const grouped = groupByField(issues);
  const validCount = updated_fields.filter(u => u.status === "VALID").length;

  return (
    <div style={{ padding: 20, fontFamily: "Arial" }}>
      <div style={{
        padding: 15,
        borderRadius: 10,
        background: status === "INVALID" || status === "ERROR" ? "#ff4d4f" : "#52c41a",
        color: "white",
        marginBottom: 20,
      }}>
        <h2>{status === "INVALID" || status === "ERROR" ? "❌ Listing Invalid" : "✅ Listing Valid"}</h2>
        <p className="mb-1"><strong>SKU:</strong> {sku}</p>
        {submissionId && <p className="mb-0"><strong>Submission:</strong> {submissionId}</p>}
      </div>

      <div style={{ display: "flex", gap: 20, marginBottom: 20, fontWeight: "bold" }}>
        <div>Total: {issues.length}</div>
        <div style={{ color: "green" }}>Valid: {validCount}</div> 
        <div style={{ color: "red" }}>Errors: {errors}</div>
      </div>

      {issues.length > 0 && (
        <table border="1" cellPadding="10" style={{ width: "100%", borderCollapse: "collapse", borderColor: "#dee2e6" }}>
          <thead style={{ backgroundColor: "#f8f9fa" }}>
            <tr>
              <th>Field</th>
              <th>Message</th>
              <th>Severity</th>
            </tr>
          </thead>
          <tbody>
            {grouped.map(([field, fieldIssues]) =>
              fieldIssues.map((issue, idx) => (
                <tr key={`${field}-${idx}`}>
                  {idx === 0 && (
                    <td
                      rowSpan={fieldIssues.length}
                      style={{ verticalAlign: "top", fontFamily: "monospace", fontWeight: "bold" }}
                    >
                      {field}
                      {fieldIssues.length > 1 && (
                        <span style={{
                          marginLeft: 6,
                          background: "#fff1f0",
                          color: "#cf1322",
                          fontSize: 11,
                          padding: "1px 6px",
                          borderRadius: 10,
                          border: "1px solid #ffa39e",
                        }}>
                          {fieldIssues.length}
                        </span>
                      )}
                    </td>
                  )}
                  <td>{issue.message}</td>
                  <td style={{ color: issue.severity === "ERROR" ? "red" : "orange", fontWeight: "bold" }}>
                    {issue.severity}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AmazonProductListingUpdatePopup;